import React from "react";
import PropTypes from "prop-types";

function Duration({ value }) {
  const duration = parseFloat(value).toFixed(0);

  return <span>{duration} min</span>;
}

export default Duration;

Duration.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
